import React, { useEffect, useContext, useState } from "react";
import UIkit from "uikit";

import { AppContexts } from "../../../providers";
import { Modal } from "../../common/Modal";

export default ({ data, onRemove, onClose }) => {
	const { removeZone } = useContext(AppContexts.ZonesContext);

	const [pending, setPending] = useState(false);
	const [item, setItem] = useState(null);

	useEffect(() => {
		if (!data) {
			setItem(null);
		} else {
			setItem({ ...data });
		}
	}, [data]);

	const handleRemove = async (e) => {
		e.preventDefault();

		let msg = "";
		let status = "success";

		setPending(true);
		try {
			await removeZone(item);

			msg = "Item removed successfully";
			status = "success";

			if (!!onRemove) {
				onRemove();
			}
		} catch (error) {
			msg = "Failed to Remove";
			status = "danger";
		}

		UIkit.notification({
			message: msg,
			status: status,
		});

		setPending(false);
	};

	const handleClose = (e) => {
		e.preventDefault();

		if (!!onClose) {
			onClose();
		}
	};

	return (
		<Modal open={!!item} close={onClose}>
			<div className="uk-modal-dialog uk-modal-body">
				<button
					className="uk-modal-close-default"
					type="button"
					uk-close="true"
					onClick={handleClose}
				></button>
				<h2 className="uk-modal-title">Delete Zone</h2>
				<p>Are you sure you want to delete this Zone?</p>
				<p className="uk-text-right">
					<button
						className="uk-button hms-btn uk-modal-close uk-modal-delete-cancel"
						type="button"
						onClick={handleClose}
						disabled={pending}
					>
						Cancel
					</button>
					<button
						className="uk-button hms-btn hms-gray-btn"
						type="button"
						onClick={handleRemove}
						disabled={pending}
					>
						{pending ? <div data-uk-spinner="ratio: 0.5;"></div> : "Delete"}
					</button>
				</p>
			</div>
		</Modal>
	);
};
